<template>
  <v-container fluid>
    <v-data-table class="pt-3" flat :loading="loading ? '#0482fb' : null" :headers="headers" :items="Quoting.docs"
      :items-per-page="5" :search="productionsearchData" sort-by="">
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Listing des contrats à émettre</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <!-- <v-switch
            v-model="showAllFil"
            label="Afficher toutes les données"
            color="#0482fb"
            @change="showAllFillData"
            class="pt-5"
          ></v-switch> -->
        </v-toolbar>
        <v-container fluid>
          <v-expansion-panels flat style="border: 1px solid #0482fb">
            <v-expansion-panel class="elevation-0">
              <v-expansion-panel-header>
                Tri / Recherche ...
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <v-col cols="12" md="3">
                    <v-text-field outlined color="#0482fb" label="Date demande cotation début" class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify" v-model="startDate" type="date" dense flat
                      background-color="grey lighten-4"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field outlined color="#0482fb" label="Date demande cotation fin" class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify" v-model="endDate" type="date" dense flat
                      background-color="grey lighten-4"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field outlined color="#0482fb" label="Nom / Raison Sociale ..." class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify" v-model="fileName" dense flat
                      background-color="grey lighten-4"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-select outlined :items="productNameList" class="pt-5 pa-2" prepend-inner-icon="mdi-magnify" dense
                      v-model="product" flat background-color="grey lighten-4" label="Produit"></v-select>
                  </v-col>
                </v-row>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn class="white--text mr-2" color="#0482fb" pill @click="onEnter">
                    <v-icon left>
                      mdi-magnify
                    </v-icon>
                    Appliquer la recherche
                  </v-btn>
                </v-card-actions>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-container>
      </template>
      <template v-slot:item.name="{ item }">
        <td>
          {{ item.file.name }}
        </td>
      </template>

      <template v-slot:item.nature="{ item }">
        <td>
          {{ item.file.nature }}
        </td>
      </template>
      <template v-slot:item.activityField="{ item }">
        <td>
          {{ item.file.activityField }}
        </td>
      </template>
      <template v-slot:item.email="{ item }">
        <td>
          {{ item.file.email }}
        </td>
      </template>
      <template v-slot:item.phone="{ item }">
        <td>
          {{ item.file.phone }}
        </td>
      </template>

      <template v-slot:item.location="{ item }">
        <td>
          {{ item.file.location }}
        </td>
      </template>
      <template v-slot:item.observation="{ item }">
        <span v-html="item.observation"></span>
      </template>
      <template v-slot:item.product="{ item }">
        <td>
          {{ item.product.name }}
        </td>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn @click="editItemAll(item)" class="white--text ma-2" color="#0482fb" pill>
          Mise en place contrat
        </v-btn>
      </template>
    </v-data-table>
    <!--  Pop up add file-->
    <v-dialog v-model="fileDialog" max-width="unset">
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="3">
                <v-select outlined v-model="fileModal.nature" :items="natureprospect"
                  label="Nature Prospect"></v-select>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field outlined color="#0482fb" v-model="fileModal.name"
                  label="Nom / Raison Sociale"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field outlined color="#0482fb" v-model="fileModal.phone" label="Téléphone"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field outlined color="#0482fb" v-model="fileModal.email" :rules="emailRules"
                  label="Mail"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field outlined color="#0482fb" v-model="fileModal.activityField"
                  label="Domaine d'activité"></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field outlined color="#0482fb" v-model="fileModal.location" label="Localité"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3" class="pa-2 white" tile>
                <v-text-field outlined color="#0482fb" v-model="fileModal.birthday" type="date"
                  label="Date anniversaire"></v-text-field>
              </v-col>
              <v-col v-if="fileModal.nature == 'Entreprise'" cols="12">
                <h3 class="mb-6">Ajouter autres Personnel au dossier</h3>

                <v-row>
                  <v-col cols="12" sm="3">
                    <v-text-field outlined color="#0482fb" v-model="name" label="Nom et Prénoms "></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-text-field outlined color="#0482fb" v-model="contact" label="Contact"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-text-field outlined color="#0482fb" v-model="email" label="Mail"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="2">
                    <v-text-field outlined color="#0482fb" v-model="birthday" type="date"
                      label="Date anniversaire"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="1">
                    <v-btn class="white--text ma-2" depressed large @click="addPersonnel" color="success">
                      Ajouter
                    </v-btn>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <h3 class="mb-3 mt-3">Liste Personnel au dossier</h3>
                <v-divider></v-divider>

                <v-container class="grey lighten-5">
                  <v-row v-for="(item, i) in fileModal.prospects" :key="i">
                    <v-col cols="12" sm="3" class="pa-2 white" v-text="item.fullName"></v-col>
                    <v-col cols="12" sm="3" class="pa-2 white" tile v-text="item.contact"></v-col>
                    <v-col cols="12" sm="3" class="pa-2 white" tile v-text="item.email"></v-col>
                    <v-col cols="12" sm="3" class="pa-2 white" tile v-text="item.birthday"></v-col>
                    <v-col cols="12" sm="12" class="pa-2 gray" tile></v-col>
                    <v-divider></v-divider>
                  </v-row>
                </v-container>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="white--text ma-2" color="blue darken-1" text @click="close">
            Cancel
          </v-btn>
          <v-btn class="white--text ma-2" color="blue darken-1" text @click="saveProspect">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">Etes vous sûrs de vouloire supprimer cet élément ?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="white--text ma-2" color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
          <v-btn class="white--text ma-2" color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--  Pop up des Contrat-->
    <template>
      <div>
        <v-row justify="center">
          <v-dialog v-model="contractDialog" overlay transition="dialog-bottom-transition" scrollable
            max-width="1000px">
            <save-dialog v-if="contractDialog" :withContractEstablished="true" @success="successSaveContract"
              @closeDialog="closeContract" :modal="contractModal" />
          </v-dialog>
        </v-row>
      </div>
    </template>
    <!-- incoporation -->
    <v-dialog v-model="incorporationDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="text-h5">Enregistrer incoporation</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="6">
                <v-text-field outlined color="#0482fb" v-model="incorporationModal.fullName"
                  label="Nom complet"></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-select outlined :items="['Masculin', 'Feminin']" v-model="incorporationModal.sex"
                  label="Sex"></v-select>
              </v-col>
              <v-col cols="6">
                <v-text-field outlined color="#0482fb" v-model="incorporationModal.email" label="Mail"></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field outlined color="#0482fb" v-model="incorporationModal.contact"
                  label="contact"></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field outlined color="#0482fb" v-model="incorporationModal.activity"
                  label="Activite"></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field outlined color="#0482fb" v-model="incorporationModal.birthday" type="date"
                  label="Date Anniverssaire"></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="white--text ma-2" color="error darken-1" @click="closeContract">
            Retour
          </v-btn>
          <v-btn class="white--text ma-2" color="success darken-1" @click="saveIncorporation">
            Effectuer incoporation
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Retrait -->
    <v-dialog v-model="withDrawModal" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="text-h5">Effectuer un retrait</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-select outlined :items="prospectsNameList" v-model="incorporationModal.name"
                  label="Nom de l'utilisateur"></v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="white--text ma-2" color="error darken-1"
            @click="(withDrawModal = false), (incorporationModal = {})">
            Retour
          </v-btn>
          <v-btn class="white--text ma-2" color="success darken-1" :loading="loading ? '#0482fb' : null"
            @click="makeWithDraw">
            Confirmer retrait
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { defaultMethods, messages } from "@/utils/data";
import {
  addCoinsurance,
  updateCoinsurance,
  // updateContract,
  // updateRegulationClause,
  // addRegulationClause,
  // addContract,
} from "@/api/user.js";
import { addFile, updateFile } from "@/api/admin.js";
import SaveDialog from "../components/contrat/saveDialog.vue";
export default {
  name: "production",
  components: { SaveDialog },
  data: () => ({
    perssonel: [],

    items: ["NSIA", "SANLAM", "SAHAM", "ATLANTIQUE ASSURANCE"],
    natureprospect: ["Physics", "Entreprise"],
    // Catégorie branche
    categorie: [],
    Au: ["MONO", "FLOTTE"],
    MP: ["MRP", "GD", "TOUT RISQUE SAUF"],
    GB: [
      "FRAUDE",
      "DETOURNEMENT",
      "FRAUDE + DETOURNEMENT",
      "FRAUDE INFORMATIQUE",
    ],
    IA: ["NOMMES", "NON NOMMES"],
    RCCE: ["RC EXPLOITATION", "RC PROF", "RC"],
    AT: ["MARITIME", "TERRESTRE", "AERIEN", "FERROVIAIRE"],

    contractDialog: false,
    headers: [
      {
        text: "",
        value: "actions",
        align: "left",
        width: "200px",
        sortable: false,
      },
      {
        text: "Nom / Raison Sociale",
        width: "200px",
        align: "start",
        sortable: false,
        value: "name",
      },
      { text: "Nature", width: "200px", value: "nature" },
      // { text: "Description", value: "description" },
      { text: "Domaine d'activité", width: "200px", value: "activityField" },
      { text: "Mail", width: "200px", value: "email" },
      { text: "Téléphone", width: "200px", value: "phone" },
      { text: "Localité", width: "200px", value: "location" },
      { text: "Branche", width: "200px", value: "product" },
      { text: "Observations", width: "200px", value: "observation" },
    ],
    currentProduct: null,
    avenantList: [
      "Affaire Nouvelle",
      "Renouvellement",
      "Incorporation",
      "Retrait",
      "Suspension",
      "Remise en vigeur",
      "Precision",
      "Modification",
      "Resiliation",
      "Régularisation",
      "Changement d'immatriculation",
    ],
    productNameList: [],
    proposedProductNameList: [],
    companyNameList: [],
    coinsuranceCompanyNameList: [],
    CommercialNameList: [],
    prospectsNameList: [],
    contractModal: {
      accessory100: 0,
      accessory50: 0,
    },
    incorporationModal: {},
    regulationClauseModal: {
      reminderDate: "",
      companyRequestDate: "",
      companyReturnDate: "",
      customerRequestDate: "",
      customerReturnDate: "",
    },
    pbClauseModal: {
      reminderDate: "",
      companyRequestDate: "",
      companyReturnDate: "",
      customerRequestDate: "",
      customerReturnDate: "",
    },

    coinsuranceModal: [
      {
        shareRate: 0,
        company: "",
        observation: "",
      },
    ],
    customerReturnDialog: false,
    companyReturnDialog: false,
    regulationDialog: false,
    productionsearchData: "",
    pbDialog: false,
    coinsuranceDialog: false,
    reasure: false,
    companyReturnModal: {},
    prospectdata: [],
    editedIndex: -1,
    fileModal: {
      name: "",
      nature: "",
      phone: "",
      activity: "",
      email: "",
      birthday: "",
      location: "",
      prospects: [],
    },
    defaultItem: {
      nom: "",
      Nature: "",
      Contact: "",
      Activité: "",
      Mail: "",
      Anniverssaire: "",
      Localisation: "",
    },
    email: "",
    name: "",
    contact: "",
    birthday: "",
    emailRules: [
      (v) => !!v || "E-mail is ",
      (v) => /.+@.+/.test(v) || "E-mail must be valid",
    ],
    loader: false,
    loading: false,
    fileDialog: false,
  }),

  mounted() {
    this.initQuotingRequest();
  },
  computed: {
    ...mapGetters(["Files", "Quoting", "Companies", "Products"]),
    formTitle() {
      return this.editedIndex === -1
        ? "Ajouter Dossier Production"
        : "Modifier Dossier Production ";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    contractModal() { },
    Companies() {
      this.companyNameList = defaultMethods.getNameList(this.Companies.docs);
      this.seedCoinsuranceCompanyNameList();
    },
    Products() {
      // alert('ok')
      this.productNameList = defaultMethods.getNameList(this.Products.docs);
    },
    Contract() {
      if (this.Contract) {
        this.contractModal = this.Contract;
        this.contractModal.company = defaultMethods.getItemName(
          this.Companies.docs,
          this.contractModal.company
        );
        // this.contractModal.commercial = defaultMethods.getItemName(
        //   this.Users.docs,
        //   this.contractModal.commercial
        // );

        // this.contractModal.dueDate =
        //   this.contractModal.dueDate
        // this.contractModal.effectDate =
        //   this.contractModal.effectDate
        // this.contractModal.paymentDate =
        //   this.contractModal.paymentDate
        if (this.Contract.otherInfo) {
          // clause regulation
          if (this.Contract.otherInfo.regulationClause) {
            this.regulationClauseModal = this.Contract.otherInfo.regulationClause;
          }
          // pb clause
          // clause regulation
          if (this.Contract.otherInfo.pbClause) {
            this.pbClauseModal = this.Contract.otherInfo.pbClause;
          }
          // coinsurance
          if (this.Contract.otherInfo.coinsurance) {
            this.coinsuranceModal = this.Contract.otherInfo.coinsurance;
            for (let i = 0; i < this.coinsuranceModal.length; i++) {
              this.coinsuranceModal[i].company = defaultMethods.getItemName(
                this.Companies.docs,
                this.coinsuranceModal[i].company
              );
            }
          }
        }
      } else {
        this.contractModal = {
          accessory100: 0,
          accessory50: 0,
        };
      }
    },
  },

  methods: {
    ...mapActions([
      "getQuoting",
      "getCompanies",
      "getQuotingSearch",
      "getProducts",
    ]),

    closeForm() {
      this.fileModal = {
        birthday: "",
        prospects: [],
      };
      this.fileDialog = false;
      this.dialogDelete = false;

      this.editedIndex = -1;
    },
    showAllFillData() {
      this.initQuotingRequest();
      //alert(this.showAllFil);
    },
    async makeSearchContract() {
      this.loading = true;
      try {
        await this.getQuotingSearch({
          fileName: this.fileName,
          product: this.product,
          startDate: this.startDate,
          endDate: this.endDate,
          //setUpContract: true,
          //contractEstablished: false,
        });
      } catch (error) {
        console.log(error);
        defaultMethods.dispatchError(
          this.$store,
          messages.failedToLoad("les contrats")
        );
      }
      this.loading = false;
    },
    onEnter: function () {
      this.makeSearchContract();
    },
    // files
    async initQuotingRequest() {
      this.loading = true;
      try {
        await this.getQuoting({
          setUpContract: true,
          currentYear: true,
        });
        await this.getProducts({ name: this.searchData });
        await this.getCompanies();
      } catch (error) {
        defaultMethods.dispatchError(
          this.$store,
          messages.failedToLoad("les dossiers")
        );
      }
      this.loading = false;
    },
    successSaveContract() {
      this.closeContract();
      this.initQuotingRequest();
    },
    async saveProspect() {
      this.loading = true;
      try {
        if (this.fileModal._id) {
          // update
          await updateFile({
            schema: {
              name: this.fileModal.name,
              prospects: this.fileModal.prospects,
              phone: this.fileModal.phone,
              email: this.fileModal.email,
              nature: this.fileModal.nature,
              location: this.fileModal.location,
              description: this.fileModal.description,
              activityField: this.fileModal.activityField,
              birthday: this.fileModal.birthday,
              // proposedProducts: this.fileModal.proposedProducts,
            },
            id: this.fileModal._id,
          });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.updatedSuccessfully("Dossier")
          );
          this.closeForm();
          this.initQuotingRequest();
        } else {
          // add
          await addFile(this.fileModal);
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.createdSuccessfully("Dossier")
          );
          this.closeForm();
          this.initQuotingRequest();
        }
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },
    all() {
      this.panel = [...Array(this.items.length).keys()].map((k, i) => i);
    },
    addPersonnel() {
      this.fileModal.prospects.push({
        fullName: this.name,
        email: this.email,
        contact: this.contact,
        birthday: this.birthday,
      });

      this.initPersonnelForm();
    },
    editItem(item) {
      item = defaultMethods.arrayFieldsToInteger(item);
      this.contractModal.TTCPrime = item.TTCPrime;
      this.contractModal.netPrime = item.netPrime;
      this.contractModal.cdeaoPrime = item.tax;
      this.contractModal.accessory100 = item.accessory;
    },
    editItemAll(item) {
      this.contractDialog = true;
      this.editedIndex = 1;
      //console.log(item);
      if (item.otherInfo && item.otherInfo.contract) {
        this.contractModal = Object.assign({}, item.otherInfo.contract);
      }
      this.contractModal.product = item.product.name;
      //console.log(item);
      this.contractModal.file = item.file._id;
      this.contractModal.quoting = item._id;
      if (item.otherInfo && item.otherInfo.customerReturn) {
        if (item.otherInfo.customerReturn.companyReturn) {
          this.contractModal.TACAVA =
            item.otherInfo.customerReturn.companyReturn.TACAVA;
          this.contractModal.TVA =
            item.otherInfo.customerReturn.companyReturn.TVA;
        }
        if (this.contractModal) {
          if (!this.contractModal.company) {
            this.contractModal.company =
              item.otherInfo.customerReturn.company.name;
          } else {
            this.contractModal.company = defaultMethods.getItemName(
              this.Companies.docs,
              this.contractModal.company
            );
          }
          if (item.otherInfo && item.otherInfo.customerReturn) {
            item = Object.assign(
              {},
              item.otherInfo.customerReturn.companyReturn
            );
            this.editItem(item);
          }

          //  company return
          // if (item.otherInfo.customerReturn.companyReturn) {
          //   if (!this.contractModal.TTCPrime) {
          //     this.contractModal.TTCPrime =
          //       item.otherInfo.customerReturn.companyReturn.TTCPrime;
          //   }
          //   if (!this.contractModal.netPrime) {
          //     this.contractModal.netPrime =
          //       item.otherInfo.customerReturn.companyReturn.netPrime;
          //   }
          //   if (!this.contractModal.cdeaoPrime) {
          //     this.contractModal.cdeaoPrime =
          //       item.otherInfo.customerReturn.companyReturn.tax;
          //   }
          //   if (!this.contractModal.accessory100) {
          //     this.contractModal.accessory100 =
          //       item.otherInfo.customerReturn.companyReturn.accessory;
          //   }
          // }
        }
      }
      this.contractModal.product = item.product.name;
      //console.log(item);
      this.contractModal.file = item.file._id;
      this.contractModal.quoting = item._id;

      this.contractDialog = true;
    },

    initPersonnelForm() {
      this.name = "";
      this.email = "";
      this.contact = "";
      this.birthday = "";
    },
    // Reset the panel
    none() {
      this.panel = [];
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },

    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        requestAnimationFrame(() =>
          requestAnimationFrame(() => (this.selectedOpen = true))
        );
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        requestAnimationFrame(() => requestAnimationFrame(() => open()));
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },

    closeContract() {
      this.contractDialog = false;
      this.fileDialog = false;
      this.contractModal = {
        accessory100: 0,
        accessory50: 0,
      };
    },
    updateRange({ start, end }) {
      const events = [];

      const min = new Date(`${start.date}T00:00:00`);
      const max = new Date(`${end.date}T23:59:59`);
      const days = (max.getTime() - min.getTime()) / 86400000;
      const eventCount = this.rnd(days, days + 20);

      for (let i = 0; i < eventCount; i++) {
        const allDay = this.rnd(0, 3) === 0;
        const firstTimestamp = this.rnd(min.getTime(), max.getTime());
        const first = new Date(firstTimestamp - (firstTimestamp % 900000));
        const secondTimestamp = this.rnd(2, allDay ? 288 : 8) * 900000;
        const second = new Date(first.getTime() + secondTimestamp);

        events.push({
          name: this.names[this.rnd(0, this.names.length - 1)],
          start: first,
          end: second,
          color: this.colors[this.rnd(0, this.colors.length - 1)],
          timed: !allDay,
        });
      }

      this.events = events;
    },
    // coinsurance
    seedCoinsuranceCompanyNameList() {
      this.coinsuranceCompanyNameList = defaultMethods.getNameList(
        this.Companies.docs
      );
    },
    updateCoinsuranceCompanyNameList() {
      // seed
      this.seedCoinsuranceCompanyNameList();
      console.log("here", this.coinsuranceModal);
      for (let a = 0; a < this.coinsuranceModal.lenght; a++) {
        const coinsurance = this.coinsuranceModal[a];
        for (let i = 0; i < this.coinsuranceCompanyNameList.lenght; i++) {
          console.log(coinsurance.company, this.coinsuranceCompanyNameList[i]);
          if (coinsurance.company == this.coinsuranceCompanyNameList[i])
            this.coinsuranceCompanyNameList.splice(i, 1);
        }
      }
    },
    addOneCoinsurance() {
      this.coinsuranceModal.push({});
    },
    closeInsurance() {
      this.coinsuranceDialog = false;
      // this.currentProduct = null;
      this.contractDialog = false;

      this.coinsuranceModal = [
        {
          shareRate: 0,
          company: "",
          observation: "",
        },
      ];
      this.seedCoinsuranceCompanyNameList();
    },
    removeFromCoin(id) {
      // id -= 1;
      this.coinsuranceModal.splice(id, 1);
      this.seedCoinsuranceCompanyNameList();
    },

    async saveCoinsurance() {
      this.loading = true;
      try {
        // we need validate data
        const result = this.validCoinsuranceData(this.coinsuranceModal);
        console.log(result);
        if (!result.success)
          return defaultMethods.dispatchError(this.$store, result.message);

        const schema = {
          data: result.data,
        };
        if (this.coinsuranceModal[0]._id) {
          // update
          await updateCoinsurance({
            schema,
            id: this.contractModal._id,
          });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.updatedSuccessfully("coassurance")
          );
          this.closeInsurance();
          this.initFile();
        } else {
          // add
          await addCoinsurance({
            schema,
            id: this.contractModal._id,
          });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.createdSuccessfully("coassurance")
          );
          this.closeInsurance();

          this.initFile();
        }
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },
    validCoinsuranceData(array) {
      const result = [];
      let totalRate = 0;

      const companyList = [];
      for (let i = 0; i < array.length; i++) {
        const item = array[i];

        // body validation

        // rate
        totalRate += Number(item.shareRate);

        // company
        if (companyList.includes(JSON.stringify(item.company)))
          throw new Error(
            `Duplicate company id  :${item.company} for coinsurance`
          );
        companyList.push(JSON.stringify(item.company));

        // get company id
        (item.company = defaultMethods.getItemId(
          this.Companies.docs,
          item.company
        )),
          result.push({
            shareRate: item.shareRate,
            company: item.company,
            isPayed: item.isPayed,
            observation: item.observation,
          });
      }

      if (totalRate !== 100)
        return {
          success: false,
          message: `Total shared rate must be 100,got ${totalRate}`,
        };

      return {
        success: true,
        data: result,
      };
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },

    addProspect() {
      this.editedIndex = -1;
      this.fileModal = {
        birthday: "",
        prospects: [],
      };
      this.fileDialog = true;
    },
    updateProspect(item) {
      this.editedIndex = 1;
      this.fileModal = Object.assign({}, item);
      this.fileDialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.prospectdata.indexOf(item);
      this.fileModal = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.prospectdata.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.fileModal = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.fileModal = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.prospectdata[this.editedIndex], this.fileModal);
      } else {
        this.prospectdata.push(this.fileModal);
      }
      this.close();
    },
  },
};
</script>

<style scoped>

</style>
